import { IPartLineDetail } from './PartLineDetail';
import { ICouponDetail } from './CouponDetail';

export enum DBPIPResponseType {
  Error,
  Split,
  Standard,
  Supercedence,
}

interface IDbpipError {
  responseType: DBPIPResponseType.Error;
  errors: string[];
}

interface IDbpipSplit {
  responseType: DBPIPResponseType.Split;
  splitList: Array<{ partNum: string; quantity: number }>;
}

interface IDbpipStandard {
  responseType: DBPIPResponseType.Standard;
  partLinesDetails: IPartLineDetail[];
  couponDetail: ICouponDetail[];
}

interface IDbpipSupercedence {
  responseType: DBPIPResponseType.Supercedence;
  partLinesDetails: IPartLineDetail[];
  couponDetail: ICouponDetail[];
}

export type IDbpipResponse = IDbpipError | IDbpipSplit | IDbpipStandard | IDbpipSupercedence;
